import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HttpErrorStateService {
	private fatalErrorActive = false;
	private logoutInProgress = false;
	private pendingLogoutTimer: ReturnType<typeof setTimeout> | null = null;

	isFatalErrorActive(): boolean {
		return this.fatalErrorActive;
	}

	activateFatalError(): void {
		this.fatalErrorActive = true;
		this.cancelPendingLogout();
	}

	resetFatalError(): void {
		this.fatalErrorActive = false;
	}

	isLogoutInProgress(): boolean {
		return this.logoutInProgress;
	}

	startLogout(): void {
		this.logoutInProgress = true;
	}

	stopLogout(): void {
		this.logoutInProgress = false;
	}

	scheduleLogout(action: () => void, delayMs = 200): void {
		if (this.logoutInProgress || this.pendingLogoutTimer) {
			return;
		}

		this.pendingLogoutTimer = setTimeout(() => {
			this.pendingLogoutTimer = null;

			if (this.fatalErrorActive) {
				return;
			}

			this.logoutInProgress = true;
			action();
		}, delayMs);
	}

	cancelPendingLogout(): void {
		if (this.pendingLogoutTimer) {
			clearTimeout(this.pendingLogoutTimer);
			this.pendingLogoutTimer = null;
		}
	}
}
